import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";

import SimpleBar from "simplebar-react";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { addNewRole, updateRole } from "../../../store/role/action";
import { getRoleList, resetRoleListState } from "../../../store/roleList/action";
import { getDepartment, resetDepartmentState } from "../../../store/department/action";
import { getPosition as onGetPositions, addNewPosition as onAddNewPosition, updatePosition as onUpdatePosition, deletePosition as onDeletePosition, getPositionLoading, resetPositionState } from "../../../store/position/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const rmFilterStr = /[\s~`!@#$%^&*()_+\-={[}\]|\\:;"'<,>.?/]+/g;

const Position = () => {
  const [modal, setModal] = useState(false);
  const [modalTag, setModalTag] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [companyName, setCompanyName] = useState({});
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clientLoading, clients, positions, isPositionCreated, isPositionSuccess, loading, error, companies, companyLoading, departments, departmentLoading, roleLists, isRoleCreated, isRoleSuccess, roleListloading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    positions: state.Position.positions,
    isPositionCreated: state.Position.isPositionCreated,
    isPositionSuccess: state.Position.isPositionSuccess,
    loading: state.Position.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    error: state.Position.error,
    roleLists: state.RoleList.roleLists,
    roleListloading: state.RoleList.loading,
    isRoleCreated: state.Role.isRoleCreated,
    isRoleSuccess: state.Role.isRoleSuccess,
  }));

  const [roleList, setRoleList] = useState([]);
  const [roleMethodList, setRoleMethodList] = useState([]);
  const [positionList, setPositionList] = useState([]);
  const [position, setPosition] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const [roles, setRoles] = useState(null);

  const [printDoc, setPrintDoc] = useState([]);

  const onClickDelete = (position) => {
    setPosition(position);
    setDeleteModal(true);
  };

  const handleDeletePosition = () => {
    if (position) {
      dispatch(onDeletePosition(position));
      setDeleteModal(false);
    }
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPositions = positions;
      if (type !== "all") {
        filteredPositions = positions.filter((position) => position.position_status.name === type);
      }
      setPositionList(filteredPositions);
    }
  };

  useEffect(() => {
    if (companySelected && companySelected.value) {
      dispatch(resetPositionState());
      dispatch(onGetPositions({ companyId: companySelected?.value ?? "" }));
      dispatch(resetRoleListState());
      dispatch(getRoleList({ companyId: companySelected?.value ?? "" }));
      handleGetDepartement(userData?.companyId);
    }
  }, [companySelected, isRoleCreated]);

  const handleGetDepartement = (id) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: id }));
  };

  useEffect(() => {
    var data = [];
    var opt = [];
    positions.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    setParentList(data);
  }, [positions]);

  useEffect(() => {
    if (!isEmpty(positions)) {
      let filteredPositions = positions;
      if (activeTypeTab !== "all") {
        filteredPositions = positions.filter((position) => position.position_status.name === activeTypeTab);
      }
      setPositionList(filteredPositions.map((el) => ({ ...el, isChecked: false })));
    }
    else
    {
      setPositionList([])
    }
  }, [positions]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Kode",
        isSelected: true,
        data: [],
      },
      {
        id: "par_pos",
        label: "Induk Jabatan",
        isSelected: true,
        data: [],
      },
      {
        id: "position_department",
        label: "Induk Jabatan",
        isSelected: true,
        data: [],
      },
      {
        id: "position_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (positionList.length > 0) {
      positionList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "par_pos" || doc.id === "position_department" || doc.id === "position_company") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [positionList]);

  useEffect(() => {
    setRoleList(roleLists);
  }, [roleLists]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    departments.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (departments.length > 0) {
      setDepartmentList(data);
    }
  }, [departments]);

  const toggleTag = useCallback(() => {
    if (modalTag) {
      setModalTag(false);
    } else {
      setModalTag(true);
    }
  }, [modalTag]);

  // useEffect(() => {
  //   if (isRoleCreated) {
  //     dispatch(resetPositionState());
  //     dispatch(onGetPositions());
  //   }
  // }, [dispatch, isRoleCreated]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [dispatch, modal, userType]);

  const handlePositionClick = useCallback(
    (arg) => {
      const data = arg;
      setPosition({
        id: data.id,
        companyId: data.companyId,
        clientId: data.clientId,
        name: data.name,
        code: data.code,
        position_role: data.position_role == null ? "" : data.position_role,
        sinceat: data.sinceat,
        description: data.description,
        client: data.position_client && {
          label: data.position_client ? data.position_client.name : "",
          value: data.position_client ? data.position_client.id : "",
        },
        company: data.position_company && {
          label: data.position_company ? data.position_company.name : "",
          value: data.position_company ? data.position_company.id : "",
        },
        parent: data.par_pos && {
          label: data.par_pos ? data.par_pos.name : "",
          value: data.par_pos ? data.par_pos.id : "",
        },
        department: data.position_department && {
          label: data.position_department ? data.position_department.name : "",
          value: data.position_department ? data.position_department.id : "",
        },
        status: data.position_status && {
          label: data.position_status ? data.position_status.name : "",
          value: data.position_status ? data.position_status.id : "",
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, positions, userType]
  );

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (position && position.name) ?? "",
      code: (position && position.code) ?? "",
      status: (position && position.status) || "1",
      description: (position && position.description) ?? "",
      client: (position && position.client) || clientSelected,
      company: (position && position.company) || companySelected,
      department: (position && position.department) ?? "",
      parent: (position && position.parent) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Position Name"),
      code: Yup.string().required("Please Enter Position Code"),
      company: Yup.object().required("Please Select Company"),
      department: Yup.object().required("Please Select Department"),
    }),
    onSubmit: (values) => {
      dispatch(getPositionLoading());
      if (isEdit) {
        const updatePosition = {
          id: position ? position.id : 0,
          name: values.name,
          code: values.code,
          parentId: values.parent ? values.parent.value : null,
          departmentId: values.department.value,
          description: values.description,
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onUpdatePosition(updatePosition));
        validation.resetForm();
      } else {
        const newPosition = {
          name: values.name,
          code: values.code,
          departmentId: values.department.value,
          parentId: values.parent ? values.parent.value : null,
          description: values.description,
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onAddNewPosition(newPosition));
        validation.resetForm();
      }
      toggle();
    },
  });

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePosition(element.value));
    });
    checkall.checked = false;
  };
  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = positionList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPositionList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = positionList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setPositionList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : roles && roles.split(",").indexOf("updatePosition") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handlePositionClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : roles && roles.split(",").indexOf("deletePosition") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : roles && roles.split(",").indexOf("approvePosition") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      if (data.position_role && data.position_role.method) {
                        let rmethod = data.position_role && data.position_role.method;
                        let m = rmethod.split(",");
                        setRoleMethodList(m);
                      } else {
                        setRoleMethodList([]);
                      }
                      setPosition(data);
                      toggleTag(data);
                    }}
                  >
                    Position Role
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Jabatan",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Kode",
        accessor: "code",
        filterable: true,
      },
      {
        Header: "Induk Jabatan",
        accessor: "par_pos.name",
        filterable: true,
      },
      {
        Header: "Departemen",
        accessor: "position_department.name",
        filterable: true,
      },
      {
        Header: "Perusahaan",
        accessor: "position_company.name",
        filterable: true,
      },
      {
        Header: `Status`,
        accessor: "billing_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [positionList, handlePositionClick, userType, roles, toggleTag, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = positionList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPositionList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => positionList, [positionList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handlePositionStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetPositions(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPositionList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetPositionState());
    dispatch(onGetPositions({ companyId: companySelected?.value ?? "" }));
  };

  const submitRole = () => {
    let ele = document.querySelectorAll(".checked-method-all");
    let arrData = "";
    ele.forEach((ele) => {
      if (ele.checked === true) {
        arrData += ele.value + ",";
      }
    });
    if (position.position_role || position.roleId) {
      const data = {
        id: position.roleId,
        positionId: position ? position.id : 0,
        roleId: position.roleId,
        name: position.name,
        method: arrData.slice(0, -1),
        companyId: position.companyId,
        clientId: position.clientId,
      };
      dispatch(updateRole(data));
    } else {
      const data = {
        roleId: position.roleId,
        positionId: position ? position.id : 0,
        name: position.name,
        method: arrData.slice(0, -1),
        companyId: position.companyId,
        clientId: position.clientId,
      };
      dispatch(addNewRole(data));
    }
    toggleTag();
  };

  const checkAllRole = () => {
    let checkall = document.getElementById("SwitchCheck");
    let ele = document.querySelectorAll(".checked-all");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const checkSubRole = (child, parent) => {
    let checkall = document.getElementById(parent);
    let ele = document.querySelectorAll("." + child);

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  document.title = "Jabatan | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={positionList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePosition} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Organisasi" pageTitle="Jabatan" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : roles && roles.split(",").indexOf("createPosition") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : roles && roles.split(",").indexOf("deletePosition") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="positionList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA JABATAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  handlePositionStatus(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader
                    className="bg-light p-3"
                    toggle={() => {
                      toggle();
                    }}
                  >
                    {!!isEdit ? "Ubah Jabatan" : "Tambah Jabatan"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("department", "");
                                validation.setFieldValue("parent", "");
                                validation.setFieldValue("company", e);
                                dispatch(setBranchSelect(null));
                                dispatch(setCompanySelect(e));
                              }}
                              options={companyList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="department-field" className="form-label">
                              Departemen&nbsp;
                              {departmentLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="department"
                              value={validation.values.department}
                              placeholder="Pilih Departemen"
                              onChange={(e) => {
                                validation.setFieldValue("department", e);
                              }}
                              options={departmentList}
                            ></Select>
                            {validation.touched.department && validation.errors.department ? <small className="error text-danger">{validation.errors.code}</small> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="parent-field" className="form-label">
                              Induk Jabatan
                            </Label>
                            <Select
                              name="parent"
                              value={validation.values.parent}
                              placeholder="Pilih Induk Jabatan"
                              onChange={(e) => {
                                validation.setFieldValue("parent", e);
                              }}
                              options={parentList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Level Jabatan
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Jabatan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="code-field" className="form-label">
                              Kode
                            </Label>
                            <Input name="code" id="code-field" className="form-control" placeholder="Isi Kode Jabatan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code} invalid={validation.touched.code && validation.errors.code ? true : false} />
                            {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="active-status" className="form-label">
                              Status
                            </Label>
                            <Select
                              name="status"
                              value={validation.values.status}
                              placeholder="Pilih Status"
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              options={statusActiveData}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" rows={5} placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggle();
                          }}
                        >
                          Batal
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalTag" isOpen={modalTag} centered size="xl" style={{ width: "90%" }}>
                  <ModalHeader className="bg-light p-3" toggle={toggleTag}>
                    Tambah Role
                  </ModalHeader>
                  <ModalBody>
                    <Card>
                      <CardBody className="pt-0 pb-0">
                        <div className="row">
                          <div className="col-md-2">
                            <div className="form-check form-switch form-switch-custom form-switch-success mb-3">
                              <Input className="form-check-input" type="checkbox" role="switch" id="SwitchCheck" defaultChecked={false} onClick={() => checkAllRole()} />
                              <Label className="form-check-label text-uppercase" htmlFor="SwitchCheck">
                                Check All Role
                              </Label>
                            </div>
                          </div>
                          <div className="col-md-10">
                            <div className="row">
                              <div className="col-md-3"></div>
                              <div className="col-md-9">
                                <div className="row fw-semibold">
                                  <div className="col-md-1">
                                    <i className="ri-eye-line fs-15"></i>
                                  </div>
                                  <div className="col-md-1">
                                    <i className="ri-add-line fs-15"></i>
                                  </div>
                                  <div className="col-md-1">
                                    <i className="ri-pencil-line fs-15"></i>
                                  </div>
                                  <div className="col-md-1">
                                    <i className="ri-delete-bin-line fs-15"></i>
                                  </div>
                                  <div className="col-md-2">Approve</div>
                                  <div className="col-md-2">HR/Inv/Jurnal</div>
                                  <div className="col-md-2">Approve Bayar</div>
                                  <div className="col-md-2">Release Bayar</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                      <SimpleBar style={{ maxHeight: "560px" }}>
                        <CardBody className="pt-0 pb-0">
                          <div className="row">
                            {roleList.map((o, i) => {
                              return (
                                <div key={i}>
                                  <div className="row">
                                    <div className="bg-soft-info mb-3">
                                      <h5 className="mt-2">{o.group}</h5>
                                    </div>
                                  </div>
                                  <div className="row">
                                    {o.child[0].child ? (
                                      <Fragment>
                                        {o.child &&
                                          o.child.map((ob, ii) => {
                                            return (
                                              <Fragment key={ii}>
                                                <div className="col-md-2 mt-3 border-bottom">
                                                  <Label className="fs-12 form-check-label text-uppercase">{ob.group}</Label>
                                                </div>
                                                <div className="col-md-10 mt-3 border-bottom">
                                                  {ob.child &&
                                                    ob.child.map((obj, idx) => {
                                                      const nameMenu = obj.menu.replaceAll(rmFilterStr, "");
                                                      return (
                                                        <div key={idx} className="mb-2">
                                                          <div className="row">
                                                            <div className="col-md-3 text-semibold">
                                                              <div className="form-check form-switch form-switch-custom form-switch-success mb-3">
                                                                {o.group !== "Reporting" && (
                                                                  <Input
                                                                    className={"form-check-input checked-all checkParent-" + nameMenu + i + idx}
                                                                    type="checkbox"
                                                                    role="switch"
                                                                    id={"checkParent-" + nameMenu + i + idx}
                                                                    value={idx}
                                                                    defaultChecked={false}
                                                                    onClick={() => {
                                                                      checkSubRole("checkChild-" + nameMenu + i + idx, "checkParent-" + nameMenu + i + idx);
                                                                    }}
                                                                  />
                                                                )}
                                                                <Label className="fs-12 form-check-label text-uppercase" htmlFor={"checkParent-" + nameMenu + i + idx}>
                                                                  {obj.menu}
                                                                </Label>
                                                              </div>
                                                            </div>
                                                            <div className="col-md-9">
                                                              <div className="row ms-1">
                                                                {obj.method &&
                                                                  obj.method.map((object, index) => {
                                                                    return (
                                                                      <div key={index} className={index < 4 ? "col-md-1 form-check form-switch form-switch-custom form-switch-success mb-3" : "col-md-2 form-check form-switch form-switch-custom form-switch-success mb-3"}>
                                                                        <Input className={"form-check-input checked-all checked-method-all checkChild-" + nameMenu + i + idx} type="checkbox" role="switch" id={"SwitchCheckChild-" + nameMenu + i + idx} value={object} defaultChecked={roleMethodList.indexOf(object) !== -1 ? true : false} />
                                                                        <Label className="form-check-label" htmlFor={"SwitchCheckChild-" + nameMenu + i + idx}>
                                                                          {/*object.split(/(?=[A-Z])/)[0].toUpperCase()*/}
                                                                        </Label>
                                                                      </div>
                                                                    );
                                                                  })}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      );
                                                    })}
                                                </div>
                                              </Fragment>
                                            );
                                          })}
                                      </Fragment>
                                    ) : (
                                      <Fragment>
                                        <div className="col-md-2"></div>
                                        <div className="col-md-10">
                                          {o.child &&
                                            o.child.map((obj, idx) => {
                                              const nameMenu = obj.menu.replaceAll(rmFilterStr, "");
                                              return (
                                                <div key={idx} className="mb-2">
                                                  <div className="row">
                                                    <div className="col-md-3 text-semibold">
                                                      <div className="form-check form-switch form-switch-custom form-switch-success mb-3">
                                                        <Input className={"form-check-input checked-all checkParent-" + nameMenu + i + idx} type="checkbox" role="switch" id={"checkParent-" + nameMenu + i + idx} value={idx} defaultChecked={false} onClick={() => checkSubRole("checkChild-" + nameMenu + i + idx, "checkParent-" + nameMenu + i + idx)} />
                                                        <Label className="fs-12 form-check-label text-uppercase" htmlFor={"checkParent-" + nameMenu + i + idx}>
                                                          {obj.menu}
                                                        </Label>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-9">
                                                      <div className="row ms-1">
                                                        {obj.method &&
                                                          obj.method.map((object, index) => {
                                                            return (
                                                              <div key={index} className={index < 4 ? "col-md-1 form-check form-switch form-switch-custom form-switch-success mb-3" : "col-md-2 form-check form-switch form-switch-custom form-switch-success mb-3"}>
                                                                <Input className={"form-check-input checked-all checked-method-all checkChild-" + nameMenu + i + idx} type="checkbox" role="switch" id={"SwitchCheckChild-" + nameMenu + i + idx} value={object} defaultChecked={roleMethodList.indexOf(object) !== -1 ? true : false} />
                                                                <Label className="form-check-label" htmlFor={"SwitchCheckChild-" + nameMenu + i + idx}>
                                                                  {/*object.split(/(?=[A-Z])/)[0].toUpperCase()*/}
                                                                </Label>
                                                              </div>
                                                            );
                                                          })}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            })}
                                        </div>
                                      </Fragment>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </CardBody>
                      </SimpleBar>
                    </Card>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleTag();
                        }}
                      >
                        Batal
                      </button>
                      <button type="submit" className="btn btn-success" onClick={() => submitRole()}>
                        <span className="d-flex align-items-center">
                          <span className="flex-grow-1 me-2">Simpan</span>
                          {roleListloading && (
                            <Spinner size="sm" className="flex-shrink-0" role="status">
                              Loading...
                            </Spinner>
                          )}
                        </span>
                      </button>
                    </div>
                  </div>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Position;
